import { render } from "./AstopiaTable.vue?vue&type=template&id=752bf903"
import script from "./AstopiaTable.vue?vue&type=script&lang=js"
export * from "./AstopiaTable.vue?vue&type=script&lang=js"

import "./AstopiaTable.vue?vue&type=style&index=0&id=752bf903&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__